export const CLASSNAME = 'bai-assistant';
